// Custom FAQ 

document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('.faq-heading-row');
    const contents = document.querySelectorAll('.faq-content-row');

    if (buttons.length === 0) return;

    buttons.forEach((button, index) => {
        const spanElement = button.querySelector('.faq-heading-plus');
      
        button.addEventListener('click', function() {
            const content = contents[index];
            if (!content) return;

            if (content.style.height === '0px' || content.style.height === '') {
                content.style.height = 'fit-content';
                if (spanElement) spanElement.textContent = '-'; 
            } else {
                content.style.height = '0px';
                if (spanElement) spanElement.textContent = '+'; 
            }
        });
    });
});


// Custom Countdown Banner

document.addEventListener("DOMContentLoaded", () => {
    const discountContainer = document.querySelector(".discount-container");

    // Exit early if the banner doesn't exist on this page
    if (!discountContainer) return;

    const closeBtn = discountContainer.querySelector(".close-btn");
    const days = document.querySelector(".countdown-timer .days");
    const hours = document.querySelector(".countdown-timer .hours");
    const minutes = document.querySelector(".countdown-timer .minutes");
    const seconds = document.querySelector(".countdown-timer .seconds");

    // Exit if countdown elements are missing
    if (!days || !hours || !minutes || !seconds) return;

    const now = new Date();
    const dynamicDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
    const countdownDate = dynamicDate.getTime(); 

    const setCookie = (name, value, duration) => {
        const expires = new Date();
        expires.setTime(expires.getTime() + duration * 60 * 60 * 1000);
        document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
    };

    if (document.cookie.indexOf("discountClosed=true") !== -1) {
        discountContainer.style.display = "none";
        return;
    }

    if (closeBtn) {
        closeBtn.addEventListener("click", () => {
            discountContainer.style.display = "none";
            setCookie("discountClosed", "true", 24);
        });
    }

    const updateCountdown = () => {
        const now = new Date().getTime();
        const distance = countdownDate - now;

        if (distance < 0) {
            discountContainer.style.display = "none";
            clearInterval(timerInterval);
            return;
        }

        const daysValue = Math.floor(distance / (1000 * 60 * 60 * 24))
            .toString()
            .padStart(2, "0");
        const hoursValue = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
            .toString()
            .padStart(2, "0");
        const minutesValue = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
            .toString()
            .padStart(2, "0");
        const secondsValue = Math.floor((distance % (1000 * 60)) / 1000)
            .toString()
            .padStart(2, "0");

        days.innerHTML = daysValue;
        hours.innerHTML = hoursValue;
        minutes.innerHTML = minutesValue;
        seconds.innerHTML = secondsValue;
    };

    const timerInterval = setInterval(updateCountdown, 1000);
    updateCountdown();
});